const DEFAULT_RETURN_URL = '/';

export function sanitizeReturnUrl(returnUrl: string | null | undefined): string {
  if (typeof returnUrl !== 'string') {
    return DEFAULT_RETURN_URL;
  }

  // Path-only URLs prevent open redirects to other origins.
  if (!returnUrl.startsWith('/') || returnUrl.startsWith('//') || returnUrl.includes('\\')) {
    return DEFAULT_RETURN_URL;
  }

  return returnUrl;
}

export function buildLoginUrl(returnUrl: string): string {
  const safeReturnUrl = sanitizeReturnUrl(returnUrl);
  const query = new URLSearchParams({ returnUrl: safeReturnUrl });
  return `/login?${query.toString()}`;
}

export function currentPathWithSearchAndHash(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
